import { Customer } from './getCustomer'
import request, { BASE_URL } from './request'

export const removePoints = async (telegramId: string): Promise<Customer> =>
  request({
    method: 'POST',
    url: `${BASE_URL}/customers/remove_points/${telegramId}`,
  })
